import React, { useEffect, useState }  from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import { DATE_FORMAT_FOR_API } from "./shared";
import { Button } from "@ts-digital/vrc";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";

import RowListDeadlines from "./rowList";
import WidgetCard from "../widget/card";
import noDeadlinesImg from "../../assets/img/nessuna-scadenza.svg";
import { FEATURE_TOGGLE_TSPAY } from "../../config";
import { DATE_FORMAT_FOR_DISPLAY } from "../../constants/constants";

import "./style.css";
import { FormattedMessage } from "react-intl";
import { getDeadlines } from "../../store/actions/deadlines/company";
import { useLocation, useNavigate } from "react-router-dom";

/** Quando richiamao il widget devo avere tutti le props required mettere un controllo nel chiamante */
const WidgetCompanyDeadlines = props => {

  const {
    classNameProp,
    goToOtherDeadlinesSubjective,    
    myType,
    isDoubleBox,
    numberItems
  } = props;

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const subjective = useSelector(state => state.deadlinesCompany.subjective);
  const isGettingDeadlines = useSelector(state => state.deadlinesCompany.isGettingDeadlines);
  const tspay= useSelector(state => state.tspay);
  const [totalTsPay, setTotalTsPay] = useState(0);

  const [configStatus, setConfigStatus] = useState("");
  const [hasAccountExpired, setHasAccountExpired] = useState(false);

  useEffect(() => {
    setConfigStatus(tspay?.configStatus?.data?.status);
  }, [tspay]);

  useEffect(() => {
    dispatch(getDeadlines(
      false,
      true,
      moment().format(DATE_FORMAT_FOR_API),
      null,
      null,
      null,
      numberItems,
      0
    ));
  }, []);

  useEffect(() => {
    let total = 0;
    let tspayAccounts = tspay.accounts.list;
    tspayAccounts.map(account => {
      if (account.amount) {
        total += account.amount;
      }
      let isValid = new Date() <= new Date(account.consentExpireDate);
      if (!isValid){
        setHasAccountExpired(true);
      }
      return null;
    });
    setTotalTsPay(parseFloat(total));
  }, [tspay.accounts.list]);

  const renderFooter = () => {
    return (
      <div style={{ textAlign: isDoubleBox ? "right" : "center" }}>
        <Button
          kind={"secondary"}
          colorScheme={"ghost"}
          onClick={e => goToOtherDeadlinesSubjective()}
        >
          <FormattedMessage id="deadlines.widget.showAll" />
        </Button>
      </div>
    );
  };

  const renderRowDeadline = (
    id,
    data,
    total,
    title,
    description,
    status,
    myType,
    paymentType,
    scope,
    paymentStatus,
    compensation,
    paymentStep
  ) => {
    const today = moment().format(DATE_FORMAT_FOR_DISPLAY);
    const tomorrow = moment()
      .add(1, "days")
      .format(DATE_FORMAT_FOR_DISPLAY);
    const yesterday = moment()
      .add(-1, "days")
      .format(DATE_FORMAT_FOR_DISPLAY);
    const isToPay = paymentStep === "to_be_paid" ? true : false;
    const isPaied = paymentStep === "paid" && total < 0 ? true : false;
    const isToCashIn = paymentStep === "to_be_collected" ? true : false;
    const isCashed = paymentStep === "collected" && total > 0 ? true : false;
    const isSuspended = paymentStatus === "suspended" ? true : false;
    const isAuthorized = paymentStep === "authorized" ? true : false;
    const isRejected = paymentStep === "rejected" ? true : false;
    const isCompensated = compensation ? true : false;
    const isPayingCustomer =
      paymentType === "item_pays" || paymentType === "item_collect"
        ? true
        : false;
    const isPending = paymentStep === "pending" ? true : false;
    const isPayingManager = paymentType === "manager_pays" ? true : false;
    const isPayingManagerCharge =
      paymentType === "manager_charge" ? true : false;

    return (
      <RowListDeadlines
        navigate={navigate}
        key={"rowD_" + id}
        data={data}
        description={description}
        fromSchedaCliente={true}        
        id={id}
        isHideBtn={false}
        title={title}
        total={total}
        status={status}
        myType={myType}
        scope={scope}
        today={today}
        tomorrow={tomorrow}
        yesterday={yesterday}
        isToPay={isToPay}
        isPaied={isPaied}
        isToCashIn={isToCashIn}
        isCashed={isCashed}
        isAuthorized={isAuthorized}
        isRejected={isRejected}
        isCompensated={isCompensated}
        isSuspended={isSuspended}
        isPayingCustomer={isPayingCustomer}
        isPayingManager={isPayingManager}
        isPayingManagerCharge={isPayingManagerCharge}
        isPending={isPending}
      />
    );
  };

  const renderContentDeadlines = () => {

    let orderedDeadlines = [];
    if (subjective !== null) {
      const sortDates = (a, b) =>
        moment(a.date).format("YYYYMMDD") - moment(b.date).format("YYYYMMDD");
      orderedDeadlines = subjective.sort(sortDates);
    }

    let arrayFirstCol = [];
    let arraySecondCol = []; // questa è valorizzata solo nel caso di box doppio = isDoubleBox a true
    if (orderedDeadlines && orderedDeadlines.length > 0) {
      /** ciclo la lista delle deadlines nello stato redux per il numero di items richiesto dal parent */
      for (let count = 0; count < numberItems; count++) {
        /** TODO separare in da pagare e da Incassare. Secondo ux se non ci sono da Incassare resta tutto
         * da pagare. Tenere in considerazione questo. Si potrebbero fare 2 chiamate in componentDidMount
         * uno per i da pagare e uno da Incassare e poi unire in subjective tramite reducer.
         * Per ora chiamo la solita lista
         * se doubleBox è true allora divido su 2 colonne e popolo prima arrayFirstCol e dopo arraySecondCol
         * altrimenti solo arrayFirstCol
         */
        let currentSubjective = orderedDeadlines[count];

        let title = <FormattedMessage id="generic.notAvailable" />;

        /** potrei avere il caso che chiedo es 8 elementi e me ne ritornano 4 perchè a db non abbiamo
         * 8 scadenze la if gestisce il caso, senza andrebbe in errore
         * */
        if (currentSubjective && currentSubjective.payment !== undefined) {
          if (
            currentSubjective.description &&
            currentSubjective.description.title
          ) {
            if (currentSubjective.description.title !== "-") {
              title =
                currentSubjective.description.details &&
                (currentSubjective.scope === "debt" ||
                  currentSubjective.scope === "credit")
                  ? currentSubjective.description.title +
                    " " +
                    currentSubjective.description.details
                  : currentSubjective.description.title;
            } else if (
              currentSubjective.description.title === "-" &&
              currentSubjective.scope === "debt" &&
              currentSubjective.counterpart &&
              currentSubjective.counterpart.description
            ) {
              title = (
                <React.Fragment>
                  <FormattedMessage id="deadlines.invoiceFrom" />
                  {" " + currentSubjective.counterpart.description}
                </React.Fragment>
              );
            } else if (
              currentSubjective.description.title === "-" &&
              currentSubjective.scope === "credit" &&
              currentSubjective.counterpart &&
              currentSubjective.counterpart.description
            ) {
              title = (
                <React.Fragment>
                  <FormattedMessage id="deadlines.invoiceTo" />
                  {" " + currentSubjective.counterpart.description}
                </React.Fragment>
              );
            }
          }

          let renderRow = renderRowDeadline(
            currentSubjective.id,
            currentSubjective.date,
            currentSubjective.totalAmount,
            title,
            currentSubjective.description
              ? currentSubjective.description.details
              : "",
            currentSubjective.status,
            myType,
            currentSubjective.payment && currentSubjective.payment.type
              ? currentSubjective.payment.type
              : null,
            currentSubjective.scope,
            currentSubjective.payment.status,
            currentSubjective.payment.compensation,
            currentSubjective.payment.step
          );

          if (isDoubleBox && count >= numberItems / 2) {
            arraySecondCol.push(renderRow);
          } else {
            arrayFirstCol.push(renderRow);
          }
        }
      }
    }

    return (
      <div className="containerFlex">
        <div
          className={
            isDoubleBox &&
            subjective !== null &&
            subjective.length > 0 &&
            subjective.length > numberItems / 2
              ? "columnFlex50 withMargin"
              : "columnFlex100"
          }
        >
          {arrayFirstCol}
        </div>
        {isDoubleBox &&
        subjective !== null &&
        subjective.length > 0 &&
        subjective.length > numberItems / 2 ? (
            <div className="columnFlex50">{arraySecondCol}</div>
          ) : null}
      </div>
    );
  };

  const renderTitle = () => {

    const notEmptyDeadlines = subjective && subjective.length > 0;
    return (
      <div>
        <div style={{display:"flex",
          width: "100%",
          marginTop: 13,
          borderBottom: notEmptyDeadlines ? "none" : "1px solid #f2f5f8",
          paddingBottom: notEmptyDeadlines ? "initial" : 8,
          justifyContent: "space-between"
        }}>
          <div

          >
            <FormattedMessage id="deadlines.title" />
          </div>
          <div style={{
            fontSize: "14px"
          }}>
            {configStatus === "LINKED" &&
            FEATURE_TOGGLE_TSPAY === "true" &&
            myType !== "STUDIO" &&
                (

                  <div className="deadlines-header-balance">
                    {hasAccountExpired ?
                      <Tooltip color={"rgb(0, 80, 117)"}
                        title={<FormattedMessage id="customerPage.landing.tsPayAccountantAlertMsg1" />}>
                        <FontAwesomeIcon
                          style={{marginRight:"7px"}}
                          className="deadlines-header-icon1"
                          color="#fdb927"
                          icon={["fas", "exclamation-triangle"]}
                        />
                      </Tooltip> : null}
                    <FontAwesomeIcon
                      style={{marginRight:"7px"}}
                      className="deadlines-header-icon1"
                      icon={["far", "university"]}
                    />
                    <span style={{marginRight:"5px"}} className="deadlines-header-text"><FormattedMessage id="deadlines.balance" /></span>
                    {!tspay.accounts.status.started &&
                tspay.accounts.status.ended ? (
                        <React.Fragment>
                          <span style={{fontSize:"20px", fontWeight: "bold"}} className="deadlines-header-amount">
                            {totalTsPay.toLocaleString("it-IT", {
                              minimumFractionDigits: 2
                            })}</span>
                          <span style={{fontSize:"20px", fontWeight: "bold"}} className="deadlines-header-amount"> €</span>

                        </React.Fragment>
                      ) : (
                        <FontAwesomeIcon
                          className="deadlines-header-tspay-spinner"
                          icon={["far", "spinner"]}
                          spin
                        />
                      )}
                  </div>
                )}
          </div>
        </div>
      </div>
    );
  };

  let emptyDeadlines = null;
  if ((!subjective || subjective.length === 0) && !isGettingDeadlines)
    emptyDeadlines = (
      <div key="noDeadlines" style={{ display: "flex" }}>
        <img src={noDeadlinesImg} alt="" />
        <div
          style={{
            fontSize: 16,
            color: "#005075",
            marginLeft: "-50px",
            marginTop: 16
          }}
        >
          <FormattedMessage id="deadlines.widget.noDeadlines" />
        </div>
      </div>
    );
  /** Nella grandezza del box valuto anche il numero di item se ne chiedo 8 e ne ricevo meno di 5 il box
   * è inutile farlo grande.
   */
  const type =
    isDoubleBox &&
    !isGettingDeadlines &&
    subjective !== null &&
    subjective.length > 0 &&
    subjective.length > 4 &&
    subjective.length > numberItems / 2
      ? classNameProp
        ? classNameProp
        : "cardSkeleton boxFluid cardSkeletonGraph"
      : 
      location &&
        location.pathname !== "/scheda-cliente"
        ? "box1_3"
        : "minHeight";

  return (
    <WidgetCard
      type={type}
      titleWidget={renderTitle()}
      footer={subjective && renderFooter()}
      isCentered={
        !subjective ||
          isGettingDeadlines ||
          (subjective && subjective.length === 0)
      }
    >
      {emptyDeadlines}
      {!isGettingDeadlines ? (
        renderContentDeadlines()
      ) : (
        <FontAwesomeIcon
          icon={["far", "circle-notch"]}
          spin
          style={{ color: "#0090d1" }}
        />
      )}
    </WidgetCard>
  );
};

export default WidgetCompanyDeadlines;
